<template>
  <div>
    <CCard>
      <CCardHeader>
        <strong>تبدیل اطلاعات</strong>
        <CButton color="secondary" size="sm" @click="backup_db()">
          بک آپ از دیتابیس
        </CButton>
      </CCardHeader>

    </CCard>
    <CRow>
      <CCol col="3">
        <CCard>
          <CCardHeader>
            <strong>لیست مشتریان</strong>
          </CCardHeader>
          <CCardBody>
            <CRow>
              <CCol>
                <CButton
                    size="sm"
                    class="m-1"
                    @click="get_template(1)"
                    color="secondary">دانلود اکسل
                </CButton>
              </CCol>
              <CCol>
                <CButton
                    size="sm"
                    class="m-1"
                    @click="open_file_selector(1)"
                    color="secondary">آپلود اکسل
                </CButton>

              </CCol>
            </CRow>
          </CCardBody>
        </CCard>

      </CCol>
      <CCol col="3">
        <CCard>
          <CCardHeader>
            <strong>قیمت و موجودی محصولات</strong>
          </CCardHeader>
          <CCardBody>
            <CRow>
              <CCol>
                <CButton
                    size="sm"
                    class="m-1"
                    @click="get_template(2)"
                    color="secondary">دانلود اکسل
                </CButton>
              </CCol>
              <CCol>
                <CButton
                    size="sm"
                    class="m-1"
                    @click="open_file_selector(2)"
                    color="secondary">آپلود اکسل
                </CButton>

              </CCol>
            </CRow>
          </CCardBody>
        </CCard>

      </CCol>
      <CCol col="3">
        <CCard>
          <CCardHeader>
            <strong>اطلاعات کامل محصولات</strong>
          </CCardHeader>
          <CCardBody>
            <CRow>
              <CCol col="12">
                <div class="control_wrapper">
                  <div class="">
                    <label>دسته بندی محصول</label>
                  </div>
                  <treeselect
                      v-model="selected_product_category"
                      :multiple="false"
                      :append-to-body="true"
                      :normalizer="normalizer_category"
                      :options="product_categories"
                      placeholder="دسته بندی محصول را انتخاب کنید"
                  />

                </div>

              </CCol>
              <CCol>
                <CButton
                    size="sm"
                    class="m-1"
                    @click="get_template(3)"
                    color="secondary">دانلود اکسل
                </CButton>
              </CCol>
              <CCol>
                <CButton
                    size="sm"
                    class="m-1"
                    @click="open_file_selector(3)"
                    color="secondary">آپلود اکسل
                </CButton>

              </CCol>
            </CRow>
          </CCardBody>
        </CCard>

      </CCol>
      <CCol col="3">
        <CCard>
          <CCardHeader>
            <strong>اعمال تغییر دسته جمعی</strong>
          </CCardHeader>
          <CCardBody>
            <CRow>
              <CCol col="12">

                <CSelect
                    :options="bulk_edit_items"
                    label="اعمال تغییر"
                    :value.sync="bulk_edit_operation"
                />
              </CCol>
              <CCol col="12">
                <CInput
                    label="شناسه مبدا"
                    v-model="bulk_edit_source_id"
                />
              </CCol>
              <CCol col="12">
                <CInput
                    label="کد مقصدهای اعمالی"
                    v-model="bulk_edit_dest_code"
                />
              </CCol>
              <CCol col="12">
                <CButton
                    size="sm"
                    class="m-1"
                    @click="bulk_edit_confirm()"
                    color="secondary">اعمال تغییرات دسته جمعی
                </CButton>
              </CCol>
            </CRow>
          </CCardBody>
        </CCard>

      </CCol>
      <CCol col="3">
        <CCard>
          <CCardHeader>
            <strong>انتشار کپی از محصول</strong>
          </CCardHeader>
          <CCardBody>
            <CRow>
              <CCol col="12">


              </CCol>
              <CCol col="12">
                <CInput
                    label="شناسه محصول مبدا"
                    v-model="bulk_copy_source_id"
                />
              </CCol>
              <CCol col="12">
                <CButton
                    size="sm"
                    class="m-1"
                    @click="open_file_selector(4)"
                    color="secondary">آپلود اکسل نام ها
                </CButton>
              </CCol>
              <CCol col="12">
              </CCol>
            </CRow>
          </CCardBody>
        </CCard>

      </CCol>
      <CCol col="3">
        <CCard>
          <CCardHeader>
            <strong>تبدیل کد محصولات</strong>
          </CCardHeader>
          <CCardBody>
            <CRow>
              <CCol col="12">
                <CInput
                    label="کد محصولات فعلی"
                    v-model="bulk_rename_source_code"
                />

              </CCol>
              <CCol col="12">
                <CInput
                    label="کد محصولات جدید"
                    v-model="bulk_rename_new_code"
                />
              </CCol>
              <CCol col="12">
                <CButton
                    size="sm"
                    class="m-1"
                    @click="bulk_rename_code_confirm()"
                    color="secondary">تغییر کد ها
                </CButton>
              </CCol>
              <CCol col="12">
              </CCol>
            </CRow>
          </CCardBody>
        </CCard>

      </CCol>
    </CRow>

    <CInputFile
        custom
        horizontal
        id="excel_uploader_file_data_convert"
        v-show="false"

        v-on:change="handleFileUpload"
    />
  </div>

</template>

<script>
import { apiUrl } from '@/api/config'
import axios from "@/api/http";
import {bus} from '../../main';
import xlsx from "json-as-xlsx";
import readXlsxFile from "read-excel-file";

import Treeselect from '@riophae/vue-treeselect'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'


import {ASYNC_SEARCH} from '@riophae/vue-treeselect'

export default {
  name: 'DataConvert',
  components: {
    Treeselect,
  },
  data() {
    return {
      selected_upload_type: 0,
      excel_file: null,
      bulk_edit_items: [
        {label: 'انتخاب کنید', value: 'select'},
        {label: 'تصاویر', value: 'images'},
        {label: 'قیمت', value: 'price'},
        {label: 'موجودی', value: 'stock'},
        {label: 'توضیحات کوتاه', value: 'short_description'},
        {label: 'توضیحات کامل', value: 'description'},
        {label: 'الگو مشخصات', value: 'property'},
        {label: 'برند', value: 'brand'},
        {label: 'تگ ها', value: 'tags'},
        {label: 'دسته بندی', value: 'categories'},
        {label: 'سئو توضیحات', value: 'meta_description'},
        {label: 'ویژگی اضافی', value: 'additional_value'},
        {label: 'باندل های قیمتی موجودی و عکس', value: 'bundle_prices'},
      ],
      
      bulk_copy_source_id: '',

      bulk_edit_operation: 'select',
      bulk_edit_source_id: '',
      bulk_edit_dest_code: '',
      product_categories: [],
      selected_product_category: null,
      bulk_rename_source_code: '',
      bulk_rename_new_code: '',
      normalizer_category(node) {
        return {
          id: node.id,
          label: node.name,
          children: node.children,
        }
      },
    }
  },
  mounted() {
    this.get_categories();
  },
  watch: {},
  methods: {
    open_file_selector(type) {
      this.selected_upload_type = type
      document.getElementById("excel_uploader_file_data_convert").click()
    },
    get_template(type) {
      if (type == 1) {
        this.get_customers();
      }
      if (type == 2) {
        this.get_products_all();
      }
      if (type == 3) {
        this.get_products_full_by_cat();
      }
    },
    get_customers() {
      var self = this;

      axios.post('/api/admin/user/get_customers', {}).then(function (response) {

        var contents = response.data;
        var pros = []

        contents.forEach(function (val) {
          if (val.credit == null) {
            val.credit = '0'
          } else {
            val.credit = val.credit.balance
          }
          pros.push({
            id: val.id,
            name: val.name,
            phone: val.phone,
            credit: val.credit,

          })
        })


        const fileName = "Customers"
        let settings = {
          fileName: fileName, // Name of the resulting spreadsheet
          extraLength: 3, // A bigger number means that columns will be wider
          writeMode: "writeFile", // The available parameters are 'WriteFile' and 'write'. This setting is optional. Useful in such cases https://docs.sheetjs.com/docs/solutions/output#example-remote-file
          writeOptions: {}, // Style options from https://docs.sheetjs.com/docs/api/write-options
          RTL: true, // Display the columns from right-to-left (the default value is false)
        }
        let data_json = [
          {
            sheet: "Sheet1",
            columns: [
              {label: "id", value: "id"}, // Top level data
              {label: "name", value: "name"}, // Top level data
              {label: "phone", value: "phone"}, // Top level data
              {label: "credit", value: "credit"}, // Top level data

            ],
            content: pros,
          },
        ]

        xlsx(data_json, settings)


      }).catch(function (error) {
      });

    },
    get_products_all() {
      var self = this;
      const formData = new FormData();
      var url = '/api/admin/product/get_products';

      axios.post(url, formData, {}).then(function (response) {

        var content_data = response.data;

        if (content_data.error == false) {

          var pros = []
          content_data.items.forEach(function (val, index) {

            pros.push({
              id: val.id,
              name: val.title.title,
              code: val.code,
              price: val.prices[0].price,
              off_price: val.prices[0].off_price,
              stock: val.prices[0].stock,
            })
          })
          const fileName = "Products"
          let settings = {
            fileName: fileName, // Name of the resulting spreadsheet
            extraLength: 3, // A bigger number means that columns will be wider
            writeMode: "writeFile", // The available parameters are 'WriteFile' and 'write'. This setting is optional. Useful in such cases https://docs.sheetjs.com/docs/solutions/output#example-remote-file
            writeOptions: {}, // Style options from https://docs.sheetjs.com/docs/api/write-options
            RTL: true, // Display the columns from right-to-left (the default value is false)
          }
          let data_json = [
            {
              sheet: "Sheet1",
              columns: [
                {label: "id", value: "id"}, // Top level data
                {label: "name", value: "name"}, // Top level data
                {label: "code", value: "code"}, // Top level data
                {label: "price", value: "price"}, // Top level data
                {label: "off_price", value: "off_price"}, // Top level data
                {label: "stock", value: "stock"}, // Top level data
              ],
              content: pros,
            },
          ]

          xlsx(data_json, settings)

        } else {
          self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

        }

      })
          .catch(function (error) {
            console.log(error);
          });

    },
    get_products_full_by_cat() {
      var self = this;
      const formData = new FormData();
      var url = '/api/admin/product/get_products_by_cat'
      formData.append("cat_id", this.selected_product_category)


      axios.post(url, formData, {}).then(function (response) {

        var content_data = response.data;

        if (content_data.error == false) {
// console.log('JSON.parse(val.title.short_description)[\'blocks\'][0][\'data\']',JSON.parse(content_data.items[0].title.short_description)['blocks'][0]['data']['html'])
          var pros = []
          content_data.items.forEach(function (val, index) {

            pros.push({
              id: val.id,
              name: val.title.title,
              code: val.code,
              price: val.prices[0].price,
              off_price: val.prices[0].off_price,
              stock: val.prices[0].stock,
              meta_description: val.title.meta_description,
              keyword: val.title.keyword,
              seo_title: val.title.seo_title,
              short_description: JSON.parse(val.title.short_description)['blocks'][0]['data']['html'],
              description: JSON.parse(val.title.description)['blocks'][0]['data']['html'],
            })
          })
          const fileName = "ProductsFull"
          let settings = {
            fileName: fileName, // Name of the resulting spreadsheet
            extraLength: 3, // A bigger number means that columns will be wider
            writeMode: "writeFile", // The available parameters are 'WriteFile' and 'write'. This setting is optional. Useful in such cases https://docs.sheetjs.com/docs/solutions/output#example-remote-file
            writeOptions: {}, // Style options from https://docs.sheetjs.com/docs/api/write-options
            RTL: true, // Display the columns from right-to-left (the default value is false)
          }
          let data_json = [
            {
              sheet: "Sheet1",
              columns: [
                {label: "id", value: "id"}, // Top level data
                {label: "name", value: "name"}, // Top level data
                {label: "code", value: "code"}, // Top level data
                {label: "price", value: "price"}, // Top level data
                {label: "off_price", value: "off_price"}, // Top level data
                {label: "stock", value: "stock"}, // Top level data
                {label: "meta_description", value: "meta_description"}, // Top level data
                {label: "keyword", value: "keyword"}, // Top level data
                {label: "seo_title", value: "seo_title"}, // Top level data
                {label: "short_description", value: "short_description"}, // Top level data
                {label: "description", value: "description"}, // Top level data
              ],
              content: pros,
            },
          ]

          xlsx(data_json, settings)

        } else {
          self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

        }

      })
          .catch(function (error) {
            console.log(error);
          });

    },
    handleFileUpload(files, e) {
      console.log("handle upload")
      var myfile = e.target.files[0];
      if (myfile == null) {
        return
      }

      // e.target.value = '';
      // e.target.files = '';
      this.excel_file = myfile

      this.read_ecel()
      // e.target = null

    },
    read_ecel() {
      var self = this
      try {
        if (this.excel_file) {
          readXlsxFile(this.excel_file).then((rows) => {
            // `rows` is an array of rows

            if (self.selected_upload_type == 2) {//upload products
              var excel_fields = []
              var excel_items = []
              if (rows.length > 0) {
                for (var i = 0; i < rows.length; i++) {
                  var row = rows[i];
                  if (i == 0) {
                    row.forEach(function (val, index) {
                      excel_fields.push({label: val, key: val})
                    })
                  } else {
                    var item = {};
                    row.forEach(function (val, index) {
                      item[rows[0][index]] = val
                    })
                    excel_items.push(item)
                  }


                }

              }
              self.upload_excel_products_price(excel_items);
            }
            if (self.selected_upload_type == 4) {//upload products
              var excel_items = []
              if (rows.length > 0) {
                for (var i = 0; i < rows.length; i++) {

                      excel_items.push(rows[i][0])
                  }

              }
              self.bulk_copy_product_excel(excel_items);
            }
            console.log("read excel", excel_items, excel_fields);
            // each row being an array of cells.
          }).catch((rows) => {
            console.log("invalid file 1")
            alert('Invalid File')
          })
        }

      } catch (e) {
        console.log("invalid file 2")

        alert('Invalid File');
      }

    },
    upload_excel_products_price(items) {
      var url = '/api/admin/product/update_product_excel';
      var self = this

      var formData = new FormData();
      formData.append("items", JSON.stringify(items))
      axios.post(url, formData, {}).then(function (response) {
        self.$root.modal_component.show_api_response_modals(response);
        self.get_data()

      })
          .catch(function (error) {

            console.log(error);
          });

    },
    bulk_copy_product_excel(items) {
      var url = '/api/admin/product/bulk_copy_product_excel';
      var self = this

      var formData = new FormData();
      formData.append("source_product_id", this.bulk_copy_source_id)
      formData.append("items", JSON.stringify(items))
      axios.post(url, formData, {}).then(function (response) {
        self.$root.modal_component.show_api_response_modals(response);

      })
          .catch(function (error) {

            console.log(error);
          });

    },

    bulk_rename_code_confirm() {
      var url = '/api/admin/product/bulk_rename_product_codes';
      var self = this

      var formData = new FormData();


      formData.append("bulk_rename_source_code", this.bulk_rename_source_code)
      formData.append("bulk_rename_new_code", this.bulk_rename_new_code)
      axios.post(url, formData, {}).then(function (response) {
        if(response.data.error==0){
          self.$root.modal_component.show_success_modal("تایید",response.data.msg);
        }else{
          self.$root.modal_component.show_api_response_modals(response);

        }

      })
          .catch(function (error) {

            console.log(error);
          });

    },
    bulk_edit_confirm() {
      var url = '/api/admin/product/bulk_edit_product_types';
      var self = this

      var formData = new FormData();
      formData.append("bulk_edit_operation", this.bulk_edit_operation)
      formData.append("bulk_edit_source_id", this.bulk_edit_source_id)
      formData.append("bulk_edit_dest_code", this.bulk_edit_dest_code)
      axios.post(url, formData, {}).then(function (response) {
        self.$root.modal_component.show_api_response_modals(response);

      })
          .catch(function (error) {

            console.log(error);
          });

    },
    get_categories() {
      var self = this;
      var formData = new FormData();
      axios.post('/api/admin/product/get_categories_with_children', formData, {}).then(function (response) {

        var content_cats = response.data;

        self.product_categories = content_cats.orders

      })
          .catch(function (error) {

            console.log(error);
          });

    },
    backup_db() {
      var self = this;
      var formData = new FormData();
      axios.post('/api/admin/site/backup_db', formData, {}).then(function (response) {

        window.open(apiUrl("api/admin/site/download_backup_db/" + response.data.file));

      })
          .catch(function (error) {

            console.log(error);
          });

    },


  }
}


</script>
